import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";

/**
 * Checks to see if there are metrics in the dimensions panel redux state
 * @param state
 */
export const dimensionStateHasMetrics = (state: DimensionsPanelReduxState): boolean => {
    const metricsLength = state.metrics?.values?.length;
    if (metricsLength && metricsLength > 0) {
        return true;
    } else {
        return false;
    }
};
